import React from 'react';
import { FileText, X } from 'lucide-react';

const DocumentPromptModal = ({ isOpen, onClose, onConfirm, fileCount = 1 }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 rounded-xl max-w-md w-full shadow-xl overflow-hidden animate-in fade-in zoom-in duration-200">
                <div className="flex items-center justify-between p-4 border-b border-gray-100 dark:border-slate-700">
                    <div className="flex items-center gap-2">
                        <div className="p-2 bg-blue-50 dark:bg-blue-500/10 rounded-lg text-blue-600 dark:text-blue-400">
                            <FileText className="w-5 h-5" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                            Add to Employee Documents?
                        </h3>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-5">
                    <p className="text-sm text-gray-600 dark:text-slate-300 mb-4">
                        You've attached {fileCount} file{fileCount !== 1 ? 's' : ''}. Would you also like to add {fileCount !== 1 ? 'these files' : 'this file'} to the employee documents library?
                    </p>
                    <p className="text-xs text-gray-500 dark:text-slate-400 mb-6 bg-gray-50 dark:bg-slate-900/50 p-3 rounded-lg border border-gray-100 dark:border-slate-700">
                        If yes, the file{fileCount !== 1 ? 's' : ''} will be permanently available in each recipient's personal documents section when this task is released.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-3">
                        <button
                            onClick={() => onConfirm(false)}
                            className="flex-1 px-4 py-2 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 text-gray-700 dark:text-slate-200 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors text-sm font-medium text-center"
                        >
                            No, just attach to task
                        </button>
                        <button
                            onClick={() => onConfirm(true)}
                            className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm font-medium text-center"
                        >
                            Yes, add to documents
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentPromptModal;
